import UserSignInDialog from './UserSignInDialog.js';

class UserSignInDialogBuilder {
    static build({id, env}) {
        var el = $(`#${id}`),
            builder = new UserSignInDialogBuilder({el}),
            institution = env.getInstitution();

        builder.setInstitutionName(institution.getName());
        builder.setNotifications(institution.getNotifications());
        builder.setHasEmailAuthentication(institution.hasEmailAuthentication());
        builder.setCanBeGuest(institution.guestsAllowed());
        builder.setCanCreateAccount(institution.accountCreationAllowed());

        return UserSignInDialog.create({id, env});
    }

    constructor({el}) {
        this.el = el;
    }

    find(selector) {
        return this.el.find(selector);
    }

    setCanBeGuest(canBeGuest) {
        this.find('.user-sign-in-guest-section').toggle(canBeGuest);
        this.find('.user-sign-in-persistence-message').toggle(canBeGuest);
        this.find('.user-sign-in-account-radio-wrap').toggle(canBeGuest);
    }

    setCanCreateAccount(canCreateAccount) {
        this.find('.create-account').toggle(canCreateAccount);
    }

    setHasEmailAuthentication(hasEmailAuthentication) {
        this.find('.library-auth').toggle(!hasEmailAuthentication);
        this.find('.email-auth').toggle(hasEmailAuthentication);
        this.find('.user-sign-in-help').toggle(hasEmailAuthentication);
    }

    setInstitutionName(institutionName) {
        this.find('.institution-name').text(institutionName);
    }

    setNotifications({systemNotification, institutionNotification}) {
        this.find('.message-wrap').toggle(!!(systemNotification || institutionNotification));
        this.find('.system-message').toggle(!!systemNotification).html(systemNotification);
        this.find('.institution-message').toggle(!!institutionNotification).html(institutionNotification);

        if (!systemNotification) {
            this.find('.institution-message').css('marginTop', 0);
        }
    }
}

export default UserSignInDialogBuilder;